module.exports = __webpack_public_path__ + "static/media/ms-dhoni.aef10702.jpg";